var SocialPhoto = class extends CustomHTMLElement {
  getVideoContent(item) {
    return `
      <div class="video-wrapper__poster">
        <img loading="lazy" src="${item.imageUrl}" alt="" >
        <div class="video-wrapper__poster-content">
          <button
            type="button"
            class="video-wrapper__play-button video-wrapper__play-button--large"
          >
            <svg
              focusable="false"
              width="24"
              height="24"
              viewBox="0 0 256 256"
            >
              <path 
                fill="currentColor"
                d="M240 128a15.74 15.74 0 0 1-7.6 13.51L88.32 229.65a16 16 0 0 1-16.2.3A15.86 15.86 0 0 1 64 216.13V39.87a15.86 15.86 0 0 1 8.12-13.82a16 16 0 0 1 16.2.3l144.08 88.14A15.74 15.74 0 0 1 240 128Z"
                stroke="currentColor" 
                stroke-width="2.4"
              />
            </svg>
          </button>
        </div>
      </div>
      <template>
        <video 
          playsinline="true" 
          muted="muted"
          loop="loop"
          preload="metadata"
          poster="${item.imageUrl}"
          autoplay="false"
        >
          ${item.videoUrl ? `<source src="${item.videoUrl}" type="video/mp4">` : ""}
          ${item.shopifyVideoSources?.map((source) => `<source src="${source.url}" type="${source.mimeType}">`).join("")}
          <img src="${item.imageUrl}">
        </video>
      </template>
    `;
  }
  createItemEl(item, { next, previous, index }) {
    const div = document.createElement("div");
    div.classList = "social-photo__item";
    div.innerHTML = `
      <img src="${item.imageUrl}" />
      ${
        item.videoUrl || item.shopifyVideoSources?.length
          ? `<div class="social-photo__item-video-control"><svg width="40" height="40" viewBox="0 0 40 40" fill="none">
<circle cx="20" cy="20" r="20" fill="#ECECEC" fill-opacity="0.8"/>
<path d="M15.2422 13.2109V26.7857L25.4433 19.9983L15.2422 13.2109Z" fill="#878282"/>
<path d="M16.0859 13.2109V26.7857L26.2871 19.9983L16.0859 13.2109Z" fill="#878282"/>
<path d="M17.8516 11.7773V25.3436L28.1377 18.6241L17.8516 11.7773Z" fill="#878282"/>
<path d="M17.8771 14.6562L17.8516 28.2225L28.0782 21.4436L17.8771 14.6562Z" fill="#878282"/>
<path d="M15.2422 13.2126C15.2422 13.4355 15.2861 13.6561 15.3716 13.862C15.457 14.0679 15.5822 14.255 15.7401 14.4126C15.898 14.5702 16.0854 14.6952 16.2917 14.7805C16.498 14.8657 16.7191 14.9096 16.9424 14.9096C17.1657 14.9096 17.3868 14.8657 17.593 14.7805C17.7993 14.6952 17.9868 14.5702 18.1446 14.4126C18.3025 14.255 18.4278 14.0679 18.5132 13.862C18.5986 13.6561 18.6426 13.4355 18.6426 13.2126C18.6426 12.9898 18.5986 12.7691 18.5132 12.5632C18.4278 12.3573 18.3025 12.1703 18.1446 12.0127C17.9868 11.8551 17.7993 11.7301 17.593 11.6448C17.3868 11.5595 17.1657 11.5156 16.9424 11.5156C16.7191 11.5156 16.498 11.5595 16.2917 11.6448C16.0854 11.7301 15.898 11.8551 15.7401 12.0127C15.5822 12.1703 15.457 12.3573 15.3716 12.5632C15.2861 12.7691 15.2422 12.9898 15.2422 13.2126Z" fill="#878282"/>
<path d="M27.1435 18.3047C26.2084 18.3047 25.4433 19.0683 25.4433 20.0015C25.4433 20.9348 26.2084 21.6644 27.1435 21.6984C28.1041 21.7323 28.8522 20.9518 28.8437 20.0015C28.8352 19.0683 28.0786 18.3047 27.1435 18.3047ZM16.9424 25.092C16.0073 25.092 15.2422 25.8556 15.2422 26.7889C15.2422 27.7221 16.0073 28.4518 16.9424 28.4857C17.835 28.5197 18.6171 27.7391 18.6426 26.7889C18.6681 25.8556 17.8775 25.092 16.9424 25.092Z" fill="#878282"/>
</svg>
</div>`
          : ""
      }
      <div class="social-photo__item-description">${item.title}</div>
      <modal-content class="modal social-photo__modal" data-product-ids="${item.shopifyProductIds.join(",")}" data-index="${index}">
        <div class="modal__overlay"></div>
        <div class="modal__content social-photo__modal-content">
          <button
            type="button"
            class="modal__close-button tap-area social-photo__modal-close"
            data-action="close"
            title="close"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g>
                <path id="Vector 1292" d="M3.5 3L20.5 21" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
                <path id="Vector 1293" d="M21 3.5L3 20.5" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
              </g>
            </svg>
          </button>
          <div class="social-photo__modal-container">
            <button
              type="button"
              class="tap-area social-photo__modal-button-nav social-photo__modal-next"
              title="next"
              data-index="${next}"
            >
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <g id="home_sidebar_more2">
                  <path  d="M40 20C40 31.0463 31.0462 40 20 40C8.95375 40 -1.00666e-06 31.0463 -1.00666e-06 20C-1.00666e-06 8.95375 8.95375 0 20 0C31.0462 0 40 8.95375 40 20ZM16.6163 12.1338L24.4825 20L16.6163 27.8663C16.3886 28.102 16.2626 28.4178 16.2654 28.7455C16.2683 29.0732 16.3997 29.3868 16.6315 29.6185C16.8632 29.8503 17.1768 29.9817 17.5045 29.9846C17.8322 29.9874 18.148 29.8614 18.3837 29.6338L27.1337 20.8838C27.3681 20.6493 27.4997 20.3315 27.4997 20C27.4997 19.6685 27.3681 19.3507 27.1337 19.1163L18.3837 10.3663C18.148 10.1386 17.8322 10.0126 17.5045 10.0154C17.1768 10.0183 16.8632 10.1497 16.6315 10.3815C16.3997 10.6132 16.2683 10.9268 16.2654 11.2545C16.2626 11.5822 16.3886 11.898 16.6163 12.1338Z" fill="#E5E5E5"/>
                </g>
              </svg>
            </button>
              <button
                type="button"
                class="tap-area social-photo__modal-button-nav social-photo__modal-previous"
                title="previous"
                data-index="${previous}"
              >
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <g id="home_sidebar_more1">
                  <path  d="M0 20C0 31.0463 8.95375 40 20 40C31.0463 40 40 31.0463 40 20C40 8.95375 31.0463 0 20 0C8.95375 0 0 8.95375 0 20ZM23.3837 12.1338L15.5175 20L23.3837 27.8663C23.6114 28.102 23.7374 28.4178 23.7346 28.7455C23.7317 29.0732 23.6003 29.3868 23.3685 29.6185C23.1368 29.8503 22.8232 29.9817 22.4955 29.9846C22.1678 29.9874 21.852 29.8614 21.6163 29.6338L12.8663 20.8838C12.6319 20.6493 12.5003 20.3315 12.5003 20C12.5003 19.6685 12.6319 19.3507 12.8663 19.1163L21.6163 10.3663C21.852 10.1386 22.1678 10.0126 22.4955 10.0154C22.8232 10.0183 23.1368 10.1497 23.3685 10.3815C23.6003 10.6132 23.7317 10.9268 23.7346 11.2545C23.7374 11.5822 23.6114 11.898 23.3837 12.1338Z" fill="white"/>
                </g>
              </svg>
            </button>
            <div class="social-photo__modal-container__image">
              <div class="social-photo__modal-container__image-bg"></div>
              <button
                type="button"
                class="tap-area social-photo__modal-button-nav social-photo__modal-next"
                title="next"
                data-index="${next}"
              >
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <g id="home_sidebar_more2">
                    <path  d="M40 20C40 31.0463 31.0462 40 20 40C8.95375 40 -1.00666e-06 31.0463 -1.00666e-06 20C-1.00666e-06 8.95375 8.95375 0 20 0C31.0462 0 40 8.95375 40 20ZM16.6163 12.1338L24.4825 20L16.6163 27.8663C16.3886 28.102 16.2626 28.4178 16.2654 28.7455C16.2683 29.0732 16.3997 29.3868 16.6315 29.6185C16.8632 29.8503 17.1768 29.9817 17.5045 29.9846C17.8322 29.9874 18.148 29.8614 18.3837 29.6338L27.1337 20.8838C27.3681 20.6493 27.4997 20.3315 27.4997 20C27.4997 19.6685 27.3681 19.3507 27.1337 19.1163L18.3837 10.3663C18.148 10.1386 17.8322 10.0126 17.5045 10.0154C17.1768 10.0183 16.8632 10.1497 16.6315 10.3815C16.3997 10.6132 16.2683 10.9268 16.2654 11.2545C16.2626 11.5822 16.3886 11.898 16.6163 12.1338Z" fill="#E5E5E5"/>
                  </g>
                </svg>
              </button>
                <button
                  type="button"
                  class="tap-area social-photo__modal-button-nav social-photo__modal-previous"
                  title="previous"
                  data-index="${previous}"
                >
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <g id="home_sidebar_more1">
                    <path  d="M0 20C0 31.0463 8.95375 40 20 40C31.0463 40 40 31.0463 40 20C40 8.95375 31.0463 0 20 0C8.95375 0 0 8.95375 0 20ZM23.3837 12.1338L15.5175 20L23.3837 27.8663C23.6114 28.102 23.7374 28.4178 23.7346 28.7455C23.7317 29.0732 23.6003 29.3868 23.3685 29.6185C23.1368 29.8503 22.8232 29.9817 22.4955 29.9846C22.1678 29.9874 21.852 29.8614 21.6163 29.6338L12.8663 20.8838C12.6319 20.6493 12.5003 20.3315 12.5003 20C12.5003 19.6685 12.6319 19.3507 12.8663 19.1163L21.6163 10.3663C21.852 10.1386 22.1678 10.0126 22.4955 10.0154C22.8232 10.0183 23.1368 10.1497 23.3685 10.3815C23.6003 10.6132 23.7317 10.9268 23.7346 11.2545C23.7374 11.5822 23.6114 11.898 23.3837 12.1338Z" fill="white"/>
                  </g>
                </svg>
              </button>
              ${
                item.videoUrl || item.shopifyVideoSources?.length
                  ? `<native-video>${this.getVideoContent(item)}</native-video>`
                  : `<img loading="lazy" src="${item.imageUrl}" alt="" >`
              }
            </div>
            <div class="social-photo__modal-container__content">
              ${
                item.shopifyProductIds.length > 0
                  ? `
                <div class="social-photo__modal-products">
                  ${item.shopifyProductIds.map(() => `<div class="skeleton social-photo__modal-product__skeleton"></div>`).join("")}
                </div>
              `
                  : ""
              }
               ${
                 item.shareContent || item.shareUrl
                   ? `
                <div class="social-photo__modal-container__share">
                  <div class="social-photo__modal-container__share-title">Share the love</div>
                  <div class="social-photo__modal-container__share-items">
                    <a href="https://api.whatsapp.com/send?text=${encodeURIComponent(item.shareUrl)}" target="_blank">
                      <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M512.042667 85.333333c235.648 0 426.666667 191.018667 426.666666 426.666667s-191.018667 426.666667-426.666666 426.666667a424.704 424.704 0 0 1-214.613334-57.813334L85.546667 938.666667l57.685333-211.968A424.661333 424.661333 0 0 1 85.376 512c0-235.648 191.018667-426.666667 426.666667-426.666667zM366.634667 311.466667l-8.533334 0.341333a41.002667 41.002667 0 0 0-15.872 4.266667 55.168 55.168 0 0 0-12.544 9.728c-5.12 4.821333-8.021333 9.002667-11.136 13.056A116.48 116.48 0 0 0 294.4 410.453333c0.085333 20.906667 5.546667 41.258667 14.08 60.288 17.450667 38.485333 46.165333 79.232 84.053333 116.992 9.130667 9.088 18.090667 18.218667 27.733334 26.709334a403.114667 403.114667 0 0 0 163.84 87.296l24.234666 3.712c7.893333 0.426667 15.786667-0.170667 23.722667-0.554667a84.906667 84.906667 0 0 0 35.541333-9.856c7.082667-3.754667 10.410667-5.632 16.341334-9.386667 0 0 1.834667-1.194667 5.333333-3.84 5.76-4.266667 9.301333-7.296 14.08-12.288 3.541333-3.669333 6.613333-7.978667 8.96-12.885333 3.328-6.954667 6.656-20.224 8.021333-31.274667 1.024-8.448 0.725333-13.056 0.597334-15.914666-0.170667-4.565333-3.968-9.301333-8.106667-11.306667l-24.832-11.136s-37.12-16.170667-59.818667-26.496a21.205333 21.205333 0 0 0-7.509333-1.749333 20.565333 20.565333 0 0 0-16.128 5.418666c-0.213333-0.085333-3.072 2.346667-33.92 39.722667a14.933333 14.933333 0 0 1-15.701333 5.546667 61.013333 61.013333 0 0 1-8.149334-2.816c-5.290667-2.218667-7.125333-3.072-10.752-4.608a257.066667 257.066667 0 0 1-67.2-42.794667c-5.376-4.693333-10.368-9.813333-15.488-14.762667a268.672 268.672 0 0 1-43.52-54.101333l-2.517333-4.053333a39.381333 39.381333 0 0 1-4.352-8.746667c-1.621333-6.272 2.602667-11.306667 2.602667-11.306667s10.368-11.349333 15.189333-17.493333c4.693333-5.973333 8.661333-11.776 11.221333-15.914667 5.034667-8.106667 6.613333-16.426667 3.968-22.869333-11.946667-29.184-24.32-58.24-37.034666-87.082667-2.517333-5.717333-9.984-9.813333-16.768-10.624-2.304-0.256-4.608-0.512-6.912-0.682666a144.426667 144.426667 0 0 0-17.194667 0.170666l8.576-0.341333z" p-id="30563" fill="#000000"></path></svg>
                    </a>
                    <a href="https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(item.shareUrl)}&t=${item.shareContent.replace(/\x20/g, "+")}" target="_blank">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="facebook_facebook52 1" clip-path="url(#clip0_223_134_${item.id})">
                          <path  d="M18 9C18 4.02955 13.9705 0 9 0C4.02955 0 0 4.02955 0 9C0 13.9705 4.02955 18 9 18C13.9705 18 18 13.9705 18 9ZM6.58309 9V7.27773H7.63855V6.23618C7.63855 4.83136 8.05827 3.81927 9.59645 3.81927H11.4259V5.53745H10.1381C9.49255 5.53745 9.34609 5.96618 9.34609 6.41536V7.27773H11.331L11.0602 9H9.34609V14.1946H7.63855V9H6.58309Z" fill="#333333"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_223_134_${item.id}">
                            <rect width="18" height="18" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                    <a href="https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(item.shareUrl)}&title=${item.shareContent.replace(/\x20/g, "+")}&summary=${item.shareContent.replace(/\x20/g, "+")}&source=${item.shareOwner}" target="_blank">
                      <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15479" width="18" height="18"><path d="M512 1024C229.2224 1024 0 794.7776 0 512 0 229.2224 229.2224 0 512 0c282.7776 0 512 229.2224 512 512 0 282.7776-229.2224 512-512 512z m-137.762133-286.378667V397.380267h-102.4V737.621333h102.4z m-51.2-488.448c-33.024 0-54.5792 22.954667-53.9136 53.589334-0.682667 29.218133 20.8896 52.872533 53.248 52.872533 33.672533 0 55.2448-23.6544 55.2448-52.8896-0.682667-30.6176-21.572267-53.572267-54.5792-53.572267z m133.410133 488.448h102.4V541.405867c0-9.728 1.365333-20.1728 4.061867-26.453334 6.724267-19.456 23.569067-39.645867 51.882666-39.645866 37.034667 0 51.882667 29.917867 51.882667 73.762133V737.621333h102.4V535.842133c0-100.181333-50.517333-146.1248-117.9136-146.1248-54.562133 0-88.251733 32.7168-101.7344 54.272h-2.030933l-4.7104-46.609066h-88.9344c1.348267 29.917867 2.696533 66.0992 2.696533 108.544V737.621333z" fill="#000000" p-id="15480"></path></svg>                    </a>
                    <a href="https://twitter.com/intent/tweet?text=${item.shareContent.replace(/\x20/g, "+")}&url=${encodeURIComponent(item.shareUrl)}&via=${item.shareOwner}" target="_blank">
                      <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M512 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512z m215.04-768h-56.32l-135.0656 175.7184 5.632 8.2944L414.976 256H256l196.096 284.8256-174.3872 227.0208h55.7056l145.0496-188.8256-9.728-14.4384 139.6736 203.264h158.976l-204.8-297.8816z m-100.864 456.4992L350.208 311.3472h47.4112l275.968 401.152h-47.4112z" p-id="29423" fill="#000000"></path></svg>
                    </a>
                  </div>
                </div>
              `
                   : ""
               }
              <div class="social-photo__modal-container__social">
                ${
                  item.socialOwner
                    ? `
                  <div class="social-photo__modal-container__social-owner">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                      <g clip-path="url(#clip0_248_410_${item.id})">
                        <path d="M0 18C0 22.7739 1.89642 27.3523 5.27208 30.7279C8.64773 34.1036 13.2261 36 18 36C22.7739 36 27.3523 34.1036 30.7279 30.7279C34.1036 27.3523 36 22.7739 36 18C36 13.2261 34.1036 8.64773 30.7279 5.27208C27.3523 1.89642 22.7739 0 18 0C13.2261 0 8.64773 1.89642 5.27208 5.27208C1.89642 8.64773 0 13.2261 0 18Z" fill="#333333"/>
                        <path d="M17.9938 12.6034C15.0861 12.6034 12.5938 14.9572 12.5938 18.0034C12.5938 20.9111 14.9476 23.4034 17.9938 23.4034C20.9014 23.4034 23.3937 21.0495 23.3937 18.0034C23.3937 15.0957 20.9014 12.6034 17.9938 12.6034ZM17.9938 21.4649C16.0553 21.4649 14.5322 19.9418 14.5322 18.0034C14.5322 16.0649 16.0553 14.5418 17.9938 14.5418C19.9322 14.5418 21.4553 16.0649 21.4553 18.0034C21.4553 19.9418 19.9322 21.4649 17.9938 21.4649ZM23.5322 11.2188C22.8399 11.2188 22.2861 11.7726 22.2861 12.4649C22.2861 13.1572 22.8399 13.7111 23.5322 13.7111C24.2245 13.7111 24.7784 13.1572 24.7784 12.4649C24.7784 11.7726 24.2245 11.2187 23.5322 11.2188Z" fill="white"/>
                        <path d="M22.8502 7.61166H22.2964C20.6349 7.4732 15.3733 7.4732 13.7118 7.61166C10.5272 7.4732 7.75793 9.9655 7.61947 13.1501V13.704C7.48101 15.3655 7.48101 20.627 7.61947 22.2886C7.48101 25.4732 9.97332 28.2424 13.1579 28.3809H13.7118C15.3733 28.5194 20.6349 28.5194 22.2964 28.3809C25.481 28.5194 28.2502 26.027 28.3887 22.8424V22.2886V13.704C28.5272 10.5194 26.0349 7.75012 22.8502 7.61166ZM26.1733 24.0886C25.7579 25.0578 25.0656 25.7501 24.2349 26.027C20.2195 26.5809 16.0656 26.5809 11.9118 26.027C10.9425 25.6117 10.2502 24.9194 9.97332 24.0886C9.55793 22.0117 9.41947 19.9347 9.55793 17.9963C9.41947 15.9194 9.55793 13.8424 9.97332 11.904C10.3887 10.9347 11.081 10.2424 11.9118 9.96551C15.9272 9.41166 20.081 9.41166 24.2349 9.96551C25.2041 10.3809 25.8964 11.0732 26.1733 11.904C26.5887 13.9809 26.7272 16.0578 26.5887 17.9963C26.7272 20.0732 26.5887 22.1501 26.1733 24.0886Z" fill="white"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_248_410_${item.id}">
                          <rect width="36" height="36" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    ${item.socialOwner}
                  </div>
                `
                    : ""
                }
                
                ${
                  item.title
                    ? `
                  <div class="social-photo__modal-container__title">${item.title}</div>
                `
                    : ""
                }
                ${
                  item.description
                    ? `
                  <div class="social-photo__modal-container__description">${item.description}</div>
                `
                    : ""
                }
              </div>
              ${
                item.link
                  ? `
                <a class="social-photo__modal-container__link" href="${item.link}">
                  <span>${item.linkText}</span>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <circle cx="7" cy="7" r="6.5" stroke="#333333"/>
                    <path d="M8.56123 6.9429L8.56128 6.94927L3.44458 6.99054L3.44452 6.99054C3.38699 6.99053 3.33001 7.00185 3.27685 7.02387C3.22369 7.04588 3.17539 7.07814 3.1347 7.11883C3.09402 7.15951 3.06174 7.2078 3.03972 7.26096C3.0177 7.31412 3.00637 7.37109 3.00637 7.42862C3.00637 7.48616 3.0177 7.54313 3.03972 7.59629C3.06174 7.64944 3.09402 7.69774 3.1347 7.73842C3.17539 7.7791 3.22369 7.81137 3.27685 7.83338C3.33001 7.85539 3.38697 7.86672 3.4445 7.86671C3.44451 7.86671 3.44452 7.86671 3.44452 7.86671L8.55539 7.82548L8.55691 7.82712L8.56123 7.8318L8.56555 7.83648L6.21322 10.0081L6.21317 10.0081C6.17015 10.0469 6.13526 10.0939 6.11052 10.1463C6.08578 10.1987 6.07169 10.2555 6.06905 10.3134C6.06641 10.3713 6.07529 10.4291 6.09516 10.4836C6.11503 10.538 6.1455 10.5879 6.18482 10.6305C6.22413 10.6731 6.27149 10.7074 6.32417 10.7316C6.37685 10.7557 6.4338 10.7692 6.49171 10.7712C6.54963 10.7731 6.60736 10.7636 6.66157 10.7431C6.71577 10.7226 6.76538 10.6916 6.8075 10.6518L6.80756 10.6518L9.99544 7.7092L8.56123 6.9429ZM8.56123 6.9429L8.56118 6.93654L8.56116 6.93417L6.21322 4.76664L6.21322 4.76664C6.17093 4.72762 6.13673 4.68065 6.1126 4.62842C6.08846 4.57618 6.07485 4.5197 6.07254 4.4622C6.07024 4.40471 6.07928 4.34732 6.09916 4.29332C6.11904 4.23932 6.14936 4.18976 6.18839 4.14748L6.1884 4.14748C6.2274 4.10514 6.27436 4.07091 6.32661 4.04675C6.37886 4.0226 6.43536 4.00899 6.49288 4.00671C6.5504 4.00443 6.6078 4.01352 6.6618 4.03347C6.71579 4.05342 6.76532 4.08382 6.80755 4.12294L6.80756 4.12295M8.56123 6.9429L6.80756 4.12295M6.80756 4.12295L9.99544 7.0655L6.80756 4.12295ZM10.0994 7.56296C10.0752 7.61835 10.0398 7.66813 9.99545 7.7092V7.06551C10.0398 7.10657 10.0752 7.15636 10.0994 7.21174C10.1236 7.26713 10.136 7.32691 10.136 7.38735C10.136 7.44779 10.1236 7.50758 10.0994 7.56296Z" fill="#333333" stroke="#333333" stroke-width="0.0127316"/>
                  </svg>

                </a>
              `
                  : ""
              }
              
            </div>
          </div>
        </div>
      </modal-content>
    `;
    return div;
  }
  async loadData(id) {
    const results = await fetch(
      `https://app.zalify.com/api/social-photo-cards/${id}`,
    ).then((res) => res.json());
    return results?.data?.socialPhotoCard;
  }
  async init() {
    const { id, type } = this.dataset;
    if (!id) {
      return;
    }
    const socialPhotoCard = await this.loadData(id);
    if (!socialPhotoCard) {
      return;
    }
    const items = socialPhotoCard.socialPhotos.map((socialPhoto) => ({
      ...socialPhoto,
      shopifyProductIds: socialPhoto.shopifyProductIds.map((shopifyProductId) =>
        shopifyProductId.split("/").pop(),
      ),
    }));
    if (items.length === 0) {
      return;
    }
    this.items = items;
    if (type === "product-drawer") {
      const mainEl = this.querySelector(".social-photo__main");
      while (mainEl.firstChild) {
        mainEl.removeChild(mainEl.lastChild);
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const el = this.createItemEl(item, {
          index: i,
          next: i >= items.length - 1 ? 0 : i + 1,
          previous: i === 0 ? items.length - 1 : i - 1,
        });
        mainEl.appendChild(el);
      }
      const headerEl = this.querySelector(".social-photo__header .heading");
      if (headerEl) {
        headerEl.innerHTML = socialPhotoCard.title;
      }
    } else {
      const primaryEl = this.querySelector(".social-photo__item-primary");
      while (primaryEl.firstChild) {
        primaryEl.removeChild(primaryEl.lastChild);
      }

      const secondaryEl = this.querySelector(".social-photo__item-secondary");
      while (secondaryEl.firstChild) {
        secondaryEl.removeChild(secondaryEl.lastChild);
      }

      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const el = this.createItemEl(item, {
          index: i,
          next: i >= items.length - 1 ? 0 : i + 1,
          previous: i === 0 ? items.length - 1 : i - 1,
        });
        if (i === 0) {
          primaryEl.appendChild(el);
        } else {
          secondaryEl.appendChild(el);
        }
      }
    }
  }
  connectedCallback() {
    this.items = [];
    this.init().then(() => {
      this.models = Array.from(this.querySelectorAll(".social-photo__modal"));
      this.delegate.on("click", "div.social-photo__item", (e, el) => {
        if (e.target?.parentNode !== el) {
          return;
        }
        const modal = el.querySelector(".social-photo__modal");
        if (!modal) {
          return;
        }
        this.initModal(modal);
        modal.open = true;
      });
      this.models.forEach((modal) => {
        const closeEl = modal.querySelector(".social-photo__modal-close");
        const videoEl = modal.querySelector("native-video");
        if (!videoEl) {
          return;
        }
        closeEl.addEventListener("click", () => {
          const videoEl = modal.querySelector("native-video");
          if (videoEl) {
            const parentNode = videoEl.parentNode;
            parentNode.removeChild(videoEl);
            const newVideoEl = document.createElement("native-video");
            newVideoEl.innerHTML = this.getVideoContent(
              this.items[Number(modal.dataset.index)],
            );
            parentNode.appendChild(newVideoEl);
          }
        });
      });
      this.delegate.on("scroll", "div.social-photo__scroll", (e, el) => {
        if (el.scrollLeft === 0) {
          this.querySelector(".social-photo__nav-prev").setAttribute(
            "hidden",
            "",
          );
        } else {
          this.querySelector(".social-photo__nav-prev").removeAttribute(
            "hidden",
          );
        }
        if (el.scrollLeft + el.clientWidth === el.scrollWidth) {
          this.querySelector(".social-photo__nav-next").setAttribute(
            "hidden",
            "",
          );
        } else {
          this.querySelector(".social-photo__nav-next").removeAttribute(
            "hidden",
          );
        }
      });
      setTimeout(() => {
        this.delegate.on(
          "click",
          "button.social-photo__modal-button-nav",
          (e, el) => {
            const index = Number(el.dataset.index);
            const currentModal = this.querySelector(
              ".social-photo__modal[open]",
            );
            currentModal.open = false;
            const modal = this.models[index];
            modal.open = true;
            this.initModal(modal);
          },
        );
      }, 500);
    });
  }
  async initModal(modal) {
    const shopifyProductIds = modal.dataset.productIds?.split(",") || [];
    const products = await this.loadProducts(shopifyProductIds);
    const productsEl = modal.querySelector(".social-photo__modal-products");
    // const videoEl = modal.querySelector("native-video");
    // if (videoEl) {
    //   const parentNode = videoEl.parentNode;
    //   parentNode.removeChild(videoEl);
    //   const newVideoEl = document.createElement("native-video");
    //   newVideoEl.innerHTML = this.getVideoContent(this.items[Number(modal.dataset.index)]);
    //   parentNode.appendChild(newVideoEl);
    // }
    if (products.length > 0) {
      productsEl.innerHTML = products
        .map(
          (product) => `
        <a href="${product.url}">
          <div class="social-photo__modal-products__item">
            <img loading="lazy" width="89" height="89" src="${product.image}" />
            <div class="social-photo__modal-products__item-content">
              <div class="social-photo__modal-products__item-title">${product.title}</div>
              <div class="social-photo__modal-products__item-price ">
                ${
                  product.compare_at_price_min &&
                  product.price !== product.compare_at_price_min
                    ? `
                  <span class="price price--highlight price--large">$${product.price}</span>
                  <span class="price price--compare">$${product.compare_at_price_min}</span>
                `
                    : `
                  <span class="price">$${product.price}</span>
                `
                }
                
              </div>
            </div>
          </div>
        </a>
      `,
        )
        .join("");
    } else if (productsEl) {
      productsEl.parentNode.removeChild(productsEl);
    }
  }
  loadProducts(ids) {
    return fetch(
      `/search/suggest.json?type=product&q=${ids.map((id) => `id:${id}`).join("%20OR%20")}`,
    )
      .then((res) => res.json())
      .then((response) => response?.resources?.results?.products || [])
      .catch(() => []);
  }
};
window.customElements.define("social-photo", SocialPhoto);

var ZalifyReviewsTotal = class extends CustomHTMLElement {
  loadData() {
    const { handle } = this.dataset;
    const searchParams = new URLSearchParams();
    searchParams.set("locale", "en");
    searchParams.set("special", false);
    searchParams.set("__st", false);
    searchParams.set("site", "belffin.myshopify.com");
    searchParams.set("handle", handle);
    searchParams.set("limit", 1);
    searchParams.set("page", 1);
    searchParams.set("order", "desc");
    searchParams.set("filters[star1]", "en");
    searchParams.set("filters[star2]", false);
    searchParams.set("filters[star3]", false);
    searchParams.set("filters[star4]", false);
    searchParams.set("filters[star5]", false);
    searchParams.set("filters[hasImage]", false);
    searchParams.set("filters[feature]", false);
    return fetch(`https://client.a2rev.com/api/load-reviews?t=${Date.now()}`, {
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      referrer: "https://belffin.com/",
      body: searchParams.toString(),
      method: "POST",
    }).then((res) => res.json());
  }
  async init() {
    const data = await this.loadData();
    this.setAttribute("data-total", data?.count?.total || 0);
    const onlyDisplayStars = this.dataset.onlyDisplayStars === "true";
    const content = `
      <div class="reviews__widget-total ${onlyDisplayStars ? "reviews__widget-total-stars" : ""}">
        <div class="reviews__widget-main">
          ${onlyDisplayStars ? "" : `<div class="reviews__content">Reviews(${data?.count?.total || 0})</div>`}
          <div class="reviews__avg-wrp">
            <div class="reviews__avg-bg">
              ${Array(5)
                .fill(null)
                .map(
                  () => `
                  <span>
                    <svg aria-hidden="true" focusable="false" role="img" viewBox="0 0 576 512">
                      <path fill="currentColor" d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"></path>
                    </svg>
                  </span>
                `,
                )
                .join("")}
            </div> 
            <div class="reviews__avg-active">
              ${Array(Math.ceil(data?.count?.avg_rating || 0))
                .fill(null)
                .map(
                  () => `
                  <span>
                    <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                      <path fill="currentColor" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                    </svg>
                  </span>
                `,
                )
                .join("")}
            </div>
          </div>
          <div class="reviews__avg-content">${(data?.count?.avg_rating || 0).toFixed(1)}</div>
        </div>
        ${
          onlyDisplayStars
            ? ""
            : `
          <svg width="12" height="21" viewBox="0 0 12 21" fill="none" class="reviews__widget-total__arrow-icon">
            <path d="M7.84013 10.8332L0.740134 17.9932C0.518992 18.2208 0.395291 18.5258 0.395291 18.8432C0.395291 19.1606 0.518992 19.4655 0.740134 19.6932C0.85022 19.8075 0.982239 19.8984 1.12829 19.9606C1.27434 20.0227 1.43142 20.0547 1.59013 20.0547C1.74885 20.0547 1.90593 20.0227 2.05198 19.9606C2.19803 19.8984 2.33005 19.8075 2.44013 19.6932L11.2401 10.8932C11.4613 10.6655 11.585 10.3606 11.585 10.0432C11.585 9.72576 11.4613 9.42085 11.2401 9.19316L2.44013 0.41316C2.32831 0.298254 2.1946 0.206921 2.04689 0.144556C1.89918 0.0821915 1.74047 0.0500603 1.58013 0.0500603C1.4198 0.0500603 1.26109 0.0821915 1.11338 0.144556C0.965669 0.206921 0.831955 0.298254 0.720134 0.41316C0.608262 0.524645 0.519498 0.657116 0.458931 0.802979C0.398365 0.948841 0.367188 1.10522 0.367188 1.26316C0.367188 1.4211 0.398365 1.57748 0.458931 1.72334C0.519498 1.86921 0.608262 2.00168 0.720134 2.11316L7.84013 9.13316C7.95446 9.24325 8.04541 9.37527 8.10752 9.52132C8.16964 9.66737 8.20166 9.82445 8.20166 9.98316C8.20166 10.1419 8.16964 10.299 8.10752 10.445C8.04541 10.5911 7.95446 10.7231 7.84013 10.8332Z" fill="currentColor"/>
          </svg>
        `
        }
      </div>
    `;
    this.innerHTML = content;
  }
  connectedCallback() {
    this.init();
    const reviewsEl = document.querySelector(
      `.quick-buy__reviews[data-handle="${this.dataset.handle}"]`,
    );
    this.addEventListener("click", () => {
      if (!this.dataset.total) {
        return;
      }
      reviewsEl.setAttribute("style", "height: 100%;overflow-y: hidden;");
    });
    const closeEl = document.querySelector(
      `.quick-buy__reviews[data-handle="${this.dataset.handle}"] .quick-buy__reviews-header button`,
    );
    closeEl.addEventListener("click", () => {
      reviewsEl.setAttribute("style", "");
    });
  }
};

window.customElements.define("zalify-reviews-total", ZalifyReviewsTotal);

var ColorGroup = class extends CustomHTMLElement {
  get colors() {
    const { colors } = this.dataset;
    return (
      colors
        ?.split(",")
        .map((color) => color.trim())
        .filter((color) => this.colorLabelSet.has(color)) || []
    );
  }
  isChecked() {
    const searchParams = new URLSearchParams(location.search);
    const colorSet = new Set(
      searchParams.getAll("filter.v.option.color").map((color) => color.trim()),
    );
    return this.colors.every((color) => colorSet.has(color));
  }
  connectedCallback() {
    const { colorLabels } = this.dataset;
    this.colorLabelSet = new Set(
      colorLabels?.split(",").map((color) => color.trim()) || [],
    );
    if (this.colors.every((color) => !this.colorLabelSet.has(color))) {
      console.log("hidden");
      this.setAttribute("hidden", "");
    } else {
      const checkboxEl = this.querySelector('input[type="checkbox"]');
      window.addEventListener("popstate", () => {
        if (!checkboxEl) {
          return;
        }
        const isChecked = this.isChecked();
        if (isChecked !== checkboxEl.checked) {
          checkboxEl.checked = isChecked;
        }
      });

      checkboxEl.addEventListener("change", (event) => {
        const searchParams = new URLSearchParams(location.search);
        const colorSet = new Set(
          searchParams
            .getAll("filter.v.option.color")
            .map((color) => color.trim()),
        );
        this.colors.forEach((color) => {
          if (event.currentTarget.checked) {
            if (colorSet.has(color)) {
              return;
            }
            colorSet.add(color);
          } else {
            if (!colorSet.has(color)) {
              return;
            }
            colorSet.delete(color);
          }
        });
        searchParams.delete("filter.v.option.color");
        if (colorSet.size > 0) {
          colorSet.forEach((color) => {
            searchParams.append("filter.v.option.color", color);
          });
        }
        _triggerEvent(this, "facet:criteria-changed", {
          url: `${window.location.pathname}?${searchParams.toString()}`,
        });
      });
      if (checkboxEl && this.isChecked() && !checkboxEl.checked) {
        checkboxEl.checked = true;
      }
    }

    // const searchParams = new URLSearchParams(location.search)
  }
};

window.customElements.define("color-group", ColorGroup);

var TextWithIcon = class extends CustomHTMLElement {
  connectedCallback() {
    const cardEl = document.getElementById(`${this.dataset.sectionId}_card`);
    this.delegate.on("click", (_, el) => {
      const modal = el.querySelector(".text-with-icons-v2__modal");
      if (!modal) {
        return;
      }
      if (window.innerWidth > 740) {
        modal.open = true;
      } else {
        cardEl.show?.(
          this.querySelector(".text-with-icons-v2__modal-container").cloneNode(
            true,
          ),
        );
      }
    });
  }
};

window.customElements.define("text-with-icon", TextWithIcon);

var TextWithIconCard = class extends CustomHTMLElement {
  connectedCallback() {}
  show(node) {
    while (this.firstChild) {
      this.removeChild(this.lastChild);
    }
    this.appendChild(node);
    this.style.display = "block";
    setTimeout(() => {
      this.delegate.on("click", ".text-with-icons-v2__modal-close", () => {
        this.style.display = "none";
        while (this.firstChild) {
          this.removeChild(this.lastChild);
        }
      });
    }, 0);
  }
  hide() {}
};

window.customElements.define("text-with-icon-card", TextWithIconCard);

var ShopByCategory = class extends CustomHTMLElement {
  connectedCallback() {
    this.delegate.on(
      "mouseover",
      ".shop-by-category__secondary-item",
      (_, el) => {
        const mainElements = this.querySelectorAll(
          ".shop-by-category__main > a",
        );
        for (const mainElement of mainElements) {
          if (mainElement.dataset.index === el.dataset.index) {
            mainElement.removeAttribute("hidden");
          } else {
            mainElement.setAttribute("hidden", "");
          }
        }
      },
    );
  }
};

window.customElements.define("shop-by-category", ShopByCategory);

var CollectionColorGroup = class extends CustomHTMLElement {
  connectedCallback() {
    const elements =
      this.querySelector("template").content.querySelectorAll("div");
    this.colorMap = new Map();
    for (const element of elements) {
      const { parentLabel, label, count } = element.dataset;
      let item = this.colorMap.get(parentLabel);
      if (!item) {
        item = {
          element: element.cloneNode(true),
          colors: [],
        };
      }
      item.colors.push({ label, count });
      this.colorMap.set(parentLabel, item);
    }
    this.initElements();
    window.addEventListener("popstate", () => {
      if (!this.colorMap.size) {
        return;
      }
      this.checkState();
    });
    this.checkState();
  }
  checkState() {
    const searchParams = new URLSearchParams(location.search);
    const colorSet = new Set(
      searchParams.getAll("filter.v.option.color").map((color) => color.trim()),
    );
    const matchParentLabels = Array.from(this.colorMap.keys()).filter(
      (parentLabel) => {
        const colors = this.colorMap.get(parentLabel).colors;
        return colors.every(({ label }) => colorSet.has(label));
      },
    );
    console.log("matchParentLabels", matchParentLabels);
    matchParentLabels.forEach((parentLabel) => {
      const checkboxEl = this.querySelector(`input[value="${parentLabel}"]`);
      if (checkboxEl && !checkboxEl.checked) {
        checkboxEl.checked = true;
      }
    });
  }
  initElements() {
    for (const [parentLabel, color] of this.colorMap) {
      const { element, colors } = color;
      const count = colors.reduce((acc, color) => acc + Number(color.count), 0);
      if (count === 0) {
        element.classList.add("is-disabled");
      } else {
        element
          .querySelector('input[type="checkbox"]')
          .addEventListener("change", this.onItemStateChange.bind(this));
      }
      this.appendChild(element);
    }
  }
  onItemStateChange(event) {
    const target = event.target;
    const searchParams = new URLSearchParams(location.search);
    const colorSet = new Set(
      searchParams.getAll("filter.v.option.color").map((color) => color.trim()),
    );
    const colors = this.colorMap.get(target.value).colors;
    colors.forEach(({ label: color }) => {
      if (event.currentTarget.checked) {
        if (colorSet.has(color)) {
          return;
        }
        colorSet.add(color);
      } else {
        if (!colorSet.has(color)) {
          return;
        }
        colorSet.delete(color);
      }
    });
    searchParams.delete("filter.v.option.color");
    if (colorSet.size > 0) {
      colorSet.forEach((color) => {
        searchParams.append("filter.v.option.color", color);
      });
    }
    _triggerEvent(this, "facet:criteria-changed", {
      url: `${window.location.pathname}?${searchParams.toString()}`,
    });
  }
};

window.customElements.define("collection-color-group", CollectionColorGroup);
